/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    EVMChain,
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Represents an NFT collection being tracked in the system
 * @export
 * @interface NftTracker
 */
export interface NftTracker {
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    grouping: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    contractAddress: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftTracker
     */
    evmChain: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    openSea: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    isIneligibleForLeaderboards?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    maxLimitMint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    useThirdwebEngine?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    mintVirtually?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    mintImage?: string;
}

export function NftTrackerFromJSON(json: any): NftTracker {
    return NftTrackerFromJSONTyped(json, false);
}

export function NftTrackerFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftTracker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'grouping': json['grouping'],
        'contractAddress': json['contractAddress'],
        'evmChain': EVMChainFromJSON(json['evmChain']),
        'name': json['name'],
        'openSea': json['openSea'],
        'isIneligibleForLeaderboards': !exists(json, 'isIneligibleForLeaderboards') ? undefined : json['isIneligibleForLeaderboards'],
        'maxLimitMint': !exists(json, 'maxLimitMint') ? undefined : json['maxLimitMint'],
        'useThirdwebEngine': !exists(json, 'useThirdwebEngine') ? undefined : json['useThirdwebEngine'],
        'relayerUrl': !exists(json, 'relayerUrl') ? undefined : json['relayerUrl'],
        'forwarderAddress': !exists(json, 'forwarderAddress') ? undefined : json['forwarderAddress'],
        'mintVirtually': !exists(json, 'mintVirtually') ? undefined : json['mintVirtually'],
        'mintImage': !exists(json, 'mintImage') ? undefined : json['mintImage'],
    };
}

export function NftTrackerToJSON(value?: NftTracker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'grouping': value.grouping,
        'contractAddress': value.contractAddress,
        'evmChain': EVMChainToJSON(value.evmChain),
        'name': value.name,
        'openSea': value.openSea,
        'isIneligibleForLeaderboards': value.isIneligibleForLeaderboards,
        'maxLimitMint': value.maxLimitMint,
        'useThirdwebEngine': value.useThirdwebEngine,
        'relayerUrl': value.relayerUrl,
        'forwarderAddress': value.forwarderAddress,
        'mintVirtually': value.mintVirtually,
        'mintImage': value.mintImage,
    };
}


